import get from 'lodash/get';
import createReqReducer, { initialState as rootState } from './req-reducer';

export default ({ consts, paginationConsts, counterKey }) => {
  const initialState = {
    ...rootState,
    count: 0,
    list: [],
    meta: null,
    paginationSending: false,
    pagination: { offset: 0, limit: 10 },
  };

  const defaultRequestReducer = createReqReducer(consts);

  return (state = initialState, action) => {
    switch (action.type) {
      case consts.SEND: {
        return {
          ...state,
          succeed: null,
          rejected: null,
          error: null,
          count: action.payload.count || 0,
          sending: !action.payload.silent,
        };
      }

      case consts.SUCCEED: {
        return {
          ...state,
          succeed: true,
          sending: false,
          list: action.payload,
        };
      }

      case paginationConsts.SEND: {
        return {
          ...state,
          paginationSending: true,
        };
      }

      case paginationConsts.SUCCEED: {
        return {
          ...state,
          paginationSending: false,
          list: [...state.list, ...action.payload],
        };
      }

      case paginationConsts.REJECTED:
      case paginationConsts.ERROR_ENCOUNTERED: {
        return {
          ...state,
          paginationSending: false,
        };
      }

      case paginationConsts.ADD_META:
      case consts.ADD_META: {
        return {
          ...state,
          meta: action.payload,
          count: get(action.payload, counterKey, 0),
        };
      }

      case consts.CLEAR: {
        return initialState;
      }

      default:
        return defaultRequestReducer(state, action);
    }
  };
};



// WEBPACK FOOTER //
// ./src/utils/redux/makePaginationReducer.js